import './common/prototype/array.prototype'
import './common/prototype/string.prototype'
import {
  Message
} from 'element-ui';

const ajaxResponse = function (res) {

  if (res.data.data && res.data.data.code) {
    let code = res.data.data.code;
    let msg = res.data.data.msg;
    if (code === '10000') {
      return true;
    } else if (code === '10001') {
      this.$message.error(msg);
      return false;
    } else if (code === '10002') {
      this.$message.error(msg);
      return false;
    } else if (code === '10003') {
      this.$message.error(msg);
      return false;
    } else if (code === '10004') {
      this.$message.error(msg);
      return false;
    } else if (code === '10005') {
      this.$message.error(msg);
      return false;
    } else if (code === '10006') {
      this.$message.error(msg);
      return false;
    } else if (code === '10007') {
      this.$message.error(msg);
      return false;
    } else if (code === '10008') {
      this.$message.error(msg);
      return false;
    } else if (code === '10009') {
      this.$message.error(msg);
      return false;
    }

  } else if (!res.data.data) {
    return false;
  } else {
    return true;
  }

}
/*
 * 下载文件流：
 * @param  {datas} String 数据内容
 * @param  {title} String 下载文件名称
 * content-type:Excel文件
 * type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
 * content-type:zip
 * type: "application/x-zip-compressed;charset=utf-8",
 * content-type:json
 * type: "application/application/octet-stream",
 */
const exportFile = (datas, title, type) => {
  //调用成功，在html中创建一个a元素
  let aTag = document.createElement('a');
  //创建一个blob对象
  let exportType, suffix;
  if (type === 'pdf') {
    exportType = 'application/pdf';
    suffix = '.pdf';
  } else if (type === 'zip') {
    exportType = "application/x-zip-compressed;charset=utf-8";
    suffix = '.zip'
  } else if (type === '.txt') {
    exportType = ''
    suffix = '.txt'
  } else if (type === 'excel') {
    exportType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8";
    suffix = '.xlsx'
  }
  let blob = new Blob([datas], {
    type: exportType,
  }); // 这个content是下载的文件内容，自己修改
  if (title)
    aTag.download = title + suffix; // 下载的文件名

  aTag.href = URL.createObjectURL(blob); //创建一个URL对象
  aTag.click();
  URL.revokeObjectURL(blob); //释
}
import {
  inBrowser,
  isIE,
  isChrome
} from './env.js'


const storage = (a, b) => {
  if ("undefined" == typeof b) {
    let c = localStorage.getItem(a);
    try {
      return JSON.parse(c)
    } catch (c) {
      return b
    }
  }
  localStorage.setItem(a, "string" == typeof b ? b : JSON.stringify(b))
}

//例如：format("yyyy-MM-dd hh:mm:ss");
Date.prototype.format = function (fmt) {
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    "S": this.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}


const certiType = {
  31: '海运提单',
  32: '海运货代提单',
  33: '空运提单',
  34: '空运货代提单',
  35: '贸易发票',
  36: '原厂发票',
  37: '箱单',
  38: '合同',
  39: '原产地证',
  40: '原厂箱单',
  41: '贸易箱单',
  42: '出口贸易发票',
  43: '提单附页',
  44: '发票&箱单',
  11: '出口发票',
  12: '出口箱单',
  13: '出口报关单',
  14: '报关委托书',
  15: '申报要素',
  16: '货运/订舱委托书',
  0: '未知',
  1: '快递单',
  '海运提单': 31,
  '海运货代提单': 32,
  '空运提单': 33,
  '空运货代提单': 34,
  '贸易发票': 35,
  '原厂发票': 36,
  '箱单': 37,
  '合同': 38,
  '原产地证': 39,
  '原厂箱单': 40,
  '贸易箱单': 41,
  '出口贸易发票': 42,
  '提单附页': 43,
  '发票&箱单': 44,
  '出口发票': 11,
  '出口箱单': 12,
  '出口报关单': 13,
  '报关委托书': 14,
  '申报要素': 15,
  '货运/订舱委托书': 16,
  '未知': 0,
  '快递单': 1
}

// 默认获取配置,优先级默认中级priority
let defaultRule = {
  name: '', //添加字段key
  title: '', //添加字段，字段名称
  priority: "MEDIUM", //优先级
  keywords: [],
  pageValueContains: [],
  keywordFormatSet: [],
  position: [],
  nearPosition: '',
  nearMinDistance: 0,
  nearMaxDistance: 160,
  lastRowKeywords: [],
  regexpValueFormatSet: [],
  areas: [],
  caseSensition: false,
  useTable: false,
  nearRowMerge: 0,
  rowKeyword: []
};


// 默认筛选配置
let defaultFilterRule = {
  singleValue: true,
  valueType: '',
  valuePolicy: '',
  ignoreRowKeywords: [],
  removeValueKeyword: [],
  removeValueFormatKeyword: [],
  valueContains: [],
  valueFormatSet: [],
  valueNoContains: [],
  valueNoFormatSet: [],
  minLength: '',
  maxLength: 100,
  uniqValue: false,
  deleteRow: '',
  minValue: '',
  maxValue: 5000000
};

/**
 *判断是否是数字
 *
 **/

function isRealNum (val) {
  // isNaN()函数 把空串 空格 以及NUll 按照0来处理 所以先去除，

  if (val === "" || val == null) {
    return false;
  }
  if (!isNaN(val)) {
    //对于空数组和只有一个数值成员的数组或全是数字组成的字符串，isNaN返回false，例如：'123'、[]、[2]、['123'],isNaN返回false,
    //所以如果不需要val包含这些特殊情况，则这个判断改写为if(!isNaN(val) && typeof val === 'number' )
    return true;
  } else {
    return false;
  }
}
const fileType = (path) => {
  let type;
  if (path.includes('.jpg')) {
    type = 'jpg'
  } else if (path.includes('.png')) {
    type = 'png'
  } else if (path.includes('.jpeg')) {
    type = 'jpeg'
  } else if (path.includes('.tif')) {
    type = 'tif'
  } else if (path.includes('.doc')) {
    type = 'doc'
  } else if (path.includes('.docx')) {
    type = 'docx'
  } else if (path.includes('.xls')) {
    type = 'xls'
  } else if (path.includes('.xlsx')) {
    type = 'xlsx'
  } else if (path.includes('.pdf')) {
    type = 'pdf'
  }

  return type;
}

/**
 *仅限英文数字和字符
 *
 **/
// eslint-disable-next-line no-control-regex
let isChinese = /[^\u0000-\u00FF]/;

//word、excel文档通过微软Office Web Viewer渲染
let officeView = 'https://view.officeapps.live.com/op/view.aspx?src=';

let cdn = 'https://by.cdn1.bailian-ai.com/Image'
let cdn1 = 'https://cdn.qiankebao.com.cn/yuanchu/chanpin'

/**
 * 通过图片url地址，判断文档类型
 * isOffice:doc,docx,xls,xlsx 返回true
 * isOffice:图片 返回false
 **/
const getImageType = (url) => {
  let x = url.split('.');
  let type = x[x.length - 1].toLowerCase();

  if (type === 'doc' || type === 'docx' || type === 'xls' || type === 'xlsx') {
    return {
      type: type,
      isOffice: true
    };
  } else {
    return {
      type: type,
      isOffice: false
    };
  }
}


const getOneRect = (obj) => {
  let path = [
    [obj.leftUp.x, obj.leftUp.y],
    [obj.rightUp.x, obj.rightUp.y],
    [obj.rightDown.x, obj.rightDown.y],
    [obj.leftDown.x, obj.leftDown.y]
  ];

  return {
    coordinates: path,
    id: window.btoa(Math.random()),
    type: "Rectangle"
  };
}



/**
 * 一键粘贴
 * @param  {String} id [需要粘贴的内容]
 * @param  {String} attr [需要 copy 的属性，默认是 innerText，主要用途例如赋值 a 标签上的 href 链接]
 *
 * range + selection
 *
 * 1.创建一个 range
 * 2.把内容放入 range
 * 3.把 range 放入 selection
 *
 * 注意：参数 attr 不能是自定义属性
 * 注意：对于 user-select: none 的元素无效
 * 注意：当 id 为 false 且 attr 不会空，会直接复制 attr 的内容
 */
const copyText = (text) => {
  let target = null;

  if (text) {
    target = document.createElement('div');
    target.id = 'tempTarget';
    target.style.opacity = '0';

    target.innerText = text;

    document.body.appendChild(target);


    try {
      let range = document.createRange();
      range.selectNode(target);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();

      Message.success('复制成功');

    } catch (e) {
      Message.error('复制失败');
    }

    // remove temp target
    target.parentElement.removeChild(target);
  }
}

/**
 * 解决编辑规则，下拉框没有固定
 * http://jira.bailian-ai.com/browse/TEMPLATE-634
 * 参考文章：https://juejin.cn/post/6844903856548085774
 */

const MousedownEvent = new Event('mousedown', {
  bubbles: true
});
const MouseupEvent = new Event('mouseup', {
  bubbles: true
});

const fakeClickOutSide = () => {
  document.dispatchEvent(MousedownEvent);
  document.dispatchEvent(MouseupEvent);
}


/**
 * 解决编辑规则，下拉框没有固定
 * @param  {Array} array 数组对象
 * @param  {Function} f 回调函数，按照某字段分组
 */
const groupBy = (array, f) => {
  const groups = {};
  array.forEach(function (o) {
    const group = JSON.stringify(f(o));
    groups[group] = groups[group] || [];
    groups[group].push(o);
  });
  return Object.keys(groups).map(function (group) {
    return groups[group];
  });
}

export default {
  inBrowser,
  isIE,
  isChrome,
  ajaxResponse,
  exportFile,
  storage,
  defaultRule,
  defaultFilterRule,
  officeView,
  certiType,
  isRealNum,
  isChinese,
  getImageType,
  getOneRect,
  cdn,
  cdn1,
  copyText,
  fakeClickOutSide,
  groupBy,
  fileType
}